import { postListFetcher } from '@/shared/api/list';
import { FormModalButton, type EntityField } from '@/shared/ui/list/EntityFormModal';
import { GenericListPage } from '@/shared/ui/list/GenericListPage';
import type { ListPageConfig, ListRow } from '@/shared/ui/list/types';
import { saveCarType } from './api';

const LIST_KEY = 'car-types';

interface CarType extends ListRow {
  id: number;
  name: string;
}

const FIELDS: EntityField[] = [{ name: 'name', label: 'Название', placeholder: 'Название...' }];

const config: ListPageConfig<CarType> = {
  queryKey: LIST_KEY,
  title: 'Справочник авто',
  boxTitle: 'Тип',
  errorText: 'Ошибка загрузки типов',
  fetchList: postListFetcher('/car/type/list/'),
  rows: ['types'],
  searchKeys: [
    { value: 'id', label: 'Поиск по id' },
    { value: 'name', label: 'Поиск по типу' },
  ],
  headerActions: (
    <FormModalButton
      buttonLabel="Создать"
      buttonClassName="btn btn-info pull-right"
      title="Создать тип"
      fields={FIELDS}
      initial={{ name: '' }}
      save={(v) => saveCarType(undefined, String(v.name))}
      listKey={LIST_KEY}
    />
  ),
  columns: [
    { header: 'id', sortField: 'id', render: (type) => type.id },
    { header: 'Тип', sortField: 'name', render: (type) => type.name },
    {
      header: 'Edit',
      render: (type) => (
        <FormModalButton
          buttonLabel="Edit"
          title="Редактировать тип"
          fields={FIELDS}
          initial={{ name: type.name }}
          save={(v) => saveCarType(type.id, String(v.name))}
          listKey={LIST_KEY}
        />
      ),
    },
  ],
};

export const TypesPage = () => <GenericListPage config={config} />;
